'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SelectView(props) {
  var isInvalid = props.isInvalid,
      inputRef = props.inputRef,
      passing = _objectWithoutProperties(props, ['isInvalid', 'inputRef']);

  return _react2.default.createElement(_reactSelect2.default, _extends({
    ref: inputRef,
    style: isInvalid ? { borderColor: 'red' } : null,
    className: isInvalid ? 'is-invalid-select' : '',
    matchProp: 'label',
    placeholder: '--- 選擇或輸入搜尋 ---',
    noResultsText: '--- 查無選項 ---'
  }, passing));
}

SelectView.propTypes = {
  inputRef: _propTypes.func,
  isInvalid: _propTypes.bool
};

exports.default = SelectView;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Select/Select.js
// module id = 1699
// module chunks = 0